<reroute-pin *ngFor="let pin of pins; trackBy: track" [position]="pin.position" [selected]="pin.selected"
  (menu)="menu && menu(pin.id)" (translate)="translate && translate(pin.id, $event.dx, $event.dy)"
  (down)="down && down(pin.id)" [getPointer]="getPointer"></reroute-pin>
